<template>
  <div
    class="vx-card mol-card-interaction"
    :class="{ selected: isSelected }"
    @click="jumpToBaseStation(baseStation)"
  >
    <vs-row class="mb-4">
      <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
        <span class="aisea-text-16-600-white truncate">
          {{ label }}
        </span>
      </vs-col>
    </vs-row>
    <div v-if="equipmentData.length">
      <div v-for="equipment in equipmentData" :key="equipment.hash">
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 種類 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ equipment.type }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> ストック量 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ equipment.stock }}
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-1">
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="5">
            <span class="aisea-text-12-600-white"> 更新日時 </span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="7">
            <span class="aisea-text-12-300-white truncate">
              {{ formatTimestamp(equipment) }}
            </span>
          </vs-col>
        </vs-row>
        <div v-if="equipmentData.length > 1">
          <vs-divider class="mt-0 mb-2" color="#77787A" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 石材ストックカードの一つを描画するコンポーネント
 * @parent O.EquipmentBaseStation
 * @parent O.VesselEquipmentBaseStations
 * @props baseStation: 基地局カードの情報
 * @props equipmentTypesMap: 積載物の種類
 * @props jumpToBaseStation: 拠点選択時にvuexの追跡情報とFireStoreの追跡情報を更新しする関数
 * @props isSelected: 選択中カードのフラグ
 */
import moment from "moment";
import _ from "lodash";
export default {
  name: "M.BaseStationCard",
  props: {
    baseStation: {
      type: Object,
    },
    equipmentTypesMap: {
      type: Object,
    },
    jumpToBaseStation: {
      type: Function,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultValues: {
        noneDate: "---",
        noneText: "",
        noneData: "-",
      },
    };
  },
  methods: {
    changeDisplayUnit(unit) {
      if (!unit) return "";
      if (unit === "m3") return "㎥";
      return unit;
    },
    // 日付をYYYY/MM/DD HH:mmに変換
    formatTimestamp(equipment) {
      if (!equipment) return this.defaultValues.noneDate;
      if (!equipment.timestamp) return this.defaultValues.noneDate;
      if (!equipment.timestamp.seconds) return this.defaultValues.noneDate;
      return moment(equipment.timestamp.seconds * 1000).format(
        "YYYY/MM/DD HH:mm",
      );
    },
  },
  computed: {
    // 住所
    label() {
      if (!this.baseStation) return this.defaultValues.noneText;
      return this.baseStation.label || this.defaultValues.noneText;
    },
    // 積載情報の配列
    equipmentData() {
      if (!this.equipmentTypesMap) return [];
      if (!this.baseStation) return [];
      if (!this.baseStation.data || !this.baseStation.data.length) return [];
      const equipments = this.baseStation.data.map((equipment) => {
        const targetType = this.equipmentTypesMap[equipment.equipment_type_id];
        if (targetType) {
          return {
            ...equipment,
            type: targetType.label || this.defaultValues.noneData,
            stock:
              equipment.value && targetType.unit
                ? `${Number(
                    equipment.value,
                  ).toLocaleString()}${this.changeDisplayUnit(targetType.unit)}`
                : this.defaultValues.noneData,
          };
        }
      });
      // 資機材IDで並び替え
      return _.orderBy(equipments, "equipment_type_id", "asc");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.vx-card {
  background: $aisea-blue-gray;
  cursor: pointer;
  width: 360px;
  padding: 14px;
  margin: 0 auto;
}

.mol-card-interaction {
  background-color: $aisea-blue-gray;
  &:hover {
    background-color: #6a717d;
  }
  &:active {
    background-color: #969ba4;
  }
}

.mol-card-interaction.selected {
  background-color: #1b5e83;
  outline: 2px solid #2d9cdb;

  &:hover {
    background-color: #588eac;
  }
  &:active {
    background-color: #98b6c7;
  }
}
</style>
